import { render, staticRenderFns } from "./TableButtonsAction.vue?vue&type=template&id=6fcc6d20&scoped=true&"
import script from "./TableButtonsAction.vue?vue&type=script&lang=js&"
export * from "./TableButtonsAction.vue?vue&type=script&lang=js&"
import style0 from "./TableButtonsAction.vue?vue&type=style&index=0&id=6fcc6d20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcc6d20",
  null
  
)

export default component.exports